import React, { useState } from 'react';
import Body_register from '../components/profile/register.js'

function Register() {
    return (
        <main>
            <Body_register />
        </main>

    );
}

export default Register;